function getEnPrioritizedText(text) {
    const locales = Object.keys(text).sort();
    for (const locale of locales){
        if (locale.toLocaleLowerCase().startsWith('en')) {
            return text[locale];
        }
    }
    return text[locales[0]];
}

export { getEnPrioritizedText };
//# sourceMappingURL=utils.js.map
